function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M38.0534 16C36.5867 18.5333 37.4667 21.8133 40 23.28C42.5334 24.7466 45.8134 23.8666 47.28 21.3333C48.7467 18.8 47.8667 15.52 45.3334 14.0533C42.8 12.5866 39.52 13.4666 38.0534 16Z",
  fill: "current"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M42.24 27.76L35.3067 23.76C28.96 20.08 26.7734 11.92 30.4534 5.57336L25.84 2.9067C21.6 10.2134 22.9334 19.2267 28.4267 25.0667L14.6934 48.8534L19.3067 51.52L23.3067 44.5867L27.92 47.2534L19.92 61.12L24.5334 63.7867L41.3067 34.7467C42.843 36.8314 43.7392 39.3182 43.886 41.9037C44.0328 44.4892 43.4238 47.0615 42.1334 49.3067L46.7467 51.9734C51.0134 44.64 50.16 34.4267 42.24 27.76V27.76ZM34 10.1334C35.92 11.2267 38.3467 10.5867 39.4667 8.6667C40.56 6.7467 39.92 4.32003 38 3.20003C37.0817 2.68834 35.999 2.55845 34.9857 2.83842C33.9725 3.11838 33.11 3.78574 32.5847 4.6963C32.0593 5.60686 31.9133 6.68754 32.1782 7.70487C32.443 8.7222 33.0974 9.59452 34 10.1334V10.1334Z",
  fill: "current"
});

function SvgPlayer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayer);
export default __webpack_public_path__ + "static/media/player.38290ea2.svg";
export { ForwardRef as ReactComponent };